@if (_layout == 'tab') {
  <div class="layout_tab layout_tab_main_{{_currentData.json}} layout_tab_{{_layout_id}} _main-container backNavigationViewer">
    @if (_currentData.tabType == 'horizontal') {
      <div class="layout_tab_horizontal layout_tab_horizontal_{{_layout_id}}">
        <!---action button in case of Tabs : added by abhinav chauhan-->
        <!-- <div class="d-flex justify-content-end" *ngIf="_currentData.currentAction == 'LIST' && rolePermissionService.checkAccessPermission('add', _currentData.resource) && _currentData.addAllowed">
        <ng-container [ngTemplateOutlet]="addRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
        </ng-container>
      </div> -->
      <!-- <ul class="nav nav-tabs kx-tabs"> -->
      <ul class="base-tab">
        @for (layout_key of _layout_data | keys; track layout_key) {
          <li class="nav-item">
            <a class="nav-link" [ngClass]="layout_key == _layout_id ? 'active' : ''" (click)="activeTab(layout_key)" data-toggle="tab" id="{{layout_key}}" role="tab">{{_layout_data[layout_key]['data']['layoutName'] | translate | async }}</a>
          </li>
        }
      </ul>
      @if (this._currentData.render_template) {
        <div class="base-tab-content" id="_layout_id">
          <!---action button in case of Tabs : added by abhinav chauhan-->
          @if (_currentData.currentAction == 'LIST' && rolePermissionService.checkAccessPermission('add', _currentData.resource) && _currentData.addAllowed) {
            <div class="d-flex justify-content-end">
              <ng-container [ngTemplateOutlet]="addRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
              </ng-container>
            </div>
          }
          <ng-container [ngTemplateOutlet]="layoutRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
          </ng-container>
        </div>
      }
    </div>
  }
  <div #billingMenuRef [ngClass]="( _layout_data[_layout_id] != undefined && _layout_data[_layout_id]['data']['closeSideBar'] != undefined && _layout_data[_layout_id]['data']['closeSideBar'] || sidebarOpen) ? '_main-container sidebar-mini-new' : '_main-container'">
    @if (_currentData.tabType == 'vertical') {
      <div class="_sidebar-menu-container" [triggered]="utilService.isMobile() && !billingMenuRef.classList.contains('sidebar-mini-new')" (clickOutside)="billingMenuRef.classList.add('sidebar-mini-new')">
        <div class="_sidebar-menu">
          @if (_layout_data) {
            <div class="">
              @for (layout_key of _layout_data | keys; track layout_key) {
                @if (_layout_data[layout_key]['data']['permission_required'] ? rolePermissionService.checkAccessPermission(_layout_data[layout_key]['data']['action_name'], _layout_data[layout_key]['data']['resource']) : true) {
                  @if (_layout_data[layout_key]['data']['visible'] || _layout_data[layout_key]['data']['visible'] == undefined) {
                    <div class="_wf-emr-element-indiv" [ngClass]="layout_key == _layout_id ? 'active show' : ''" id="{{layout_key}}" (click)="activeTab(layout_key)">
                      <div class="_wf-emr-icondiv">
                        <div class="_wf-sidebar-icon">
                          <img [src]="'assets/images/billing/'+_layout_data[layout_key]['data'].icon_name" alt="" class="nav-icon nav-img-icon">
                        </div>
                      </div>
                      <div class="_wf-emr-textforcompnpnet">
                        <div class="text-block-73">{{_layout_data[layout_key]['data']['layoutName'] | translate | async }}</div>
                      </div>
                    </div>
                  }
                }
              }
            </div>
          }
        </div>
        <div class="_wf-emr-element-indiv footer-toggle" (click)="billingMenuRef.classList.toggle('sidebar-mini-new');">
          <div class="_wf-emr-icondiv">
            <div><i class="fa fa-arrows-h" aria-hidden="true"></i></div>
          </div>
          <div class="_wf-emr-textforcompnpnet">
            <div class="text-block-73">{{'field.label.compress_menu' | translate | async }}</div>
          </div>
        </div>
      </div>
    }
    <div [ngClass]=" _layout_data[_layout_id] != undefined ? '_main-body container_'+parent_id :''">
      @if (_currentData.showBanner) {
        <div class="banner-container">
          @if (_currentData.bannerJson && parent_id != 2) {
            <app-resource-banner [bannerJson]="_currentData.bannerJson" (patientResult)="getBannerData($event)" (footerLinksClick)="bannerLinks($event);">
            </app-resource-banner>
          }
        </div>
      }
      <div class="billing-content-container">
        <div class="main-container-body container_{{parent_id}} p-0">
          @if (_currentData.currentAction == 'LIST' && _currentData.addAllowed && rolePermissionService.checkAccessPermission('add', _currentData.resource)) {
            <div class="pull-right card-action-link">
              <!-- <a href="javascript:void(0)" (click)="addResource(_currentData.addButton)"><span class="fa fa-plus"></span>&nbsp;Add</a> -->
              <button class="primary-btn" (click)="addResource(_currentData.addButton)">
                <span>Add</span>
                <i class="fa fa-plus-square" aria-hidden="true"></i>
              </button>
            </div>
          }
          <!-- <div class="kx-action-on-card"
          *ngIf="_currentData.addAllowed && rolePermissionService.checkAccessPermission('add', _currentData.resource) && _currentData.addAllowed">
          <ng-container [ngTemplateOutlet]="addRenderer"
            [ngTemplateOutletContext]="{_currentData:_currentData}">
          </ng-container>
        </div> -->
        <div id="v-pills-tabContent">
          @if (this._currentData.render_template && _currentData.tabType == 'vertical') {
            <div class="tab-pane kx-v-tab-pane fade active show" id="_layout_id">
              @if (_currentData && _currentData.resouceDef && _currentData.resouceDef.child_tab) {
                <div>
                  <app-ip-billing-main [parent_id]="2" [resourcename]="_currentData.resouceDef.child_tab">
                  </app-ip-billing-main>
                </div>
              } @else {
                <ng-container [ngTemplateOutlet]="layoutRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
                </ng-container>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <ng-template #customComponent>
</ng-template> -->
</div>
}
<ng-template #layoutRenderer let-_currentData='_currentData'>
  <ng-template #customComponent>
  </ng-template>
  @if (_currentData.currentAction === 'FORM_GRID' && _currentData.resouceDef.resource != undefined) {
    <div>
      @if (!utilService.isMobile()) {
        <div class="page-title-container d-flex">
          <div class="page-title flex-grow-1 ">
            <div class="mb-0 ">
              <div class="d-flex align-items-center">
                <div class="pl-2 pr-2 ">
                  <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                    <img src="assets/images/grid-back.png"></a>
                  </div>
                  <div class="">{{'menu.upload_bill' | translate | async }} </div>
                </div>
              </div>
            </div>
            <div class="component-container "></div>
          </div>
        }
        <form [formGroup]="insuranceForm" (ngSubmit)="submit()">
          <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12">
            <label  for="" class="weight">Visit ID</label>
            <input type="text" class="form-control" id="encounter_id" formControlName="encounter_id">
          </div>
          <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12">
            <label  for="" class="weight">Referral No</label>
            <input type="text" class="form-control" id="rec_no" formControlName="rec_no" disabled>
          </div>
          <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12">
            <label  for="" class="weight">Bill No</label>
            <input type="text" class="form-control" id="bill_no" formControlName="bill_no">
          </div>
          <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12">
            <label >Visit Date Time</label>
            <!-- {{disbledTimePickerRange|json}} -->
            <input type="text" ngxDaterangepickerMd [disbledTimePickerRange]="disbledTimePickerRange" class="form-control choose-date datepicker-search"
              placeholder="Choose date" showCancel="true" [timePicker]="true" [singleDatePicker]="true"
              [locale]="locale" [startKey]="'FROM'"
              [endKey]="'TO'" formControlName="admission_date_time" name="admission_date_time"
              [opens]="'center'" [showDropdowns]="true"  />
          </div>
          <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12">
            <label >Discharge Date Time</label>
            <!-- {{disbledTimePickerRange|json}} -->
            <input type="text" ngxDaterangepickerMd [disbledTimePickerRange]="disbledTimePickerRange" class="form-control choose-date datepicker-search"
              placeholder="Choose date" showCancel="true" [timePicker]="true" [singleDatePicker]="true"
              [locale]="locale" [startKey]="'FROM'"
              [endKey]="'TO'" formControlName="discharge_date_time" name="discharge_date_time"
              [opens]="'center'" [showDropdowns]="true"  />
          </div>
          <div class="kx-control col-md-4 col-sm-4 col-lg-4 col-12">
            <label >Bill Date Time</label>
            <!-- {{disbledTimePickerRange|json}} -->
            <input type="text" ngxDaterangepickerMd [disbledTimePickerRange]="disbledTimePickerRange" class="form-control choose-date datepicker-search"
              placeholder="Choose date" showCancel="true" [timePicker]="true" [singleDatePicker]="true"
              [locale]="locale" [startKey]="'FROM'"
              [endKey]="'TO'" formControlName="bill_date_time" name="bill_date_time"
              [opens]="'center'" [showDropdowns]="true"  />
          </div>
          <div class="block-heading-container ng-star-inserted">
            <div class="block-heading">Other Details</div>
            <div class="headingline"></div>
          </div>
          <div class="col-12">
            <div class="custom-op-action-bar">
              <div class="kx-control col-12 col-sm-4">
                <label class="weight" for="">Diagnosis</label>
                <div class="d-flex">
                  @if (schemeresource.datasource && schemeresource.question != undefined) {
                    <kx-multiselect-dropdown class="flex-grow-1"
                      #multiselectscheme
                      [questions]="schemeresource.question" [placeholder]="Select" [format]="schemeresource.question.format"
                      [settings]="schemeresource.defaultsetting" formControlName="diagnosis"
                      [controlName]="schemeresource" [data]="schemeresource.datasource"
                    (onSelect)="selectDiagnosis($event);" (onDeSelect)="removeDiagnosis($event)"></kx-multiselect-dropdown>
                  }
                </div>
              </div>
            </div>
          </div>
          <dhs-composite-array [current_action]="'MODIFY'" [decorator]="dec_p" formControlName="bill_details"
            [resource]="comp_patient_res" (valueAdded)="OnServiceAdd($event);" (onRemoveItem)="onSponsorRemove($event)" #compositeArrayComponent
            [config]="{'delta_update': false}">
          </dhs-composite-array>
          <div class="col text-right">
            <label><b style="padding-right: 10px;">Total Amount : {{total_service_amount}} </b></label>
          </div><br>
          <div class="block-heading-container ng-star-inserted">
            <div class="block-heading">Document Upload</div>
            <div class="headingline"></div>
          </div>
          <dhs-composite-array [current_action]="'MODIFY'" [decorator]="self" formControlName="bill_documents"
            [resource]="'insurance_payer_document'" (valueAdded)="OnServiceAdd($event);" (onRemoveItem)="onSponsorRemove($event)" #compositeArrayComponent
            [config]="{'delta_update': false}">
          </dhs-composite-array>
          <dhs-composite-array [current_action]="'MODIFY'" formControlName="payment_detail"
            [resource]="'insurance_payment_details'" (valueAdded)="OnServiceAdd($event);"
            [config]="{'delta_update': false}" (onRemoveItem)="onPaymentRemove($event)"
            #compositeArrayComponent>
          </dhs-composite-array>
          <div class="row pt-3">
            <div class="col text-center">
              <button type="submit" class="primary-btn" (click)="onSubmit($event, 'submit')">Submit</button>
            </div>
            <!-- <app-insurance-billing-form-grid (bulkActionClicked)="onBulkActionClicked($event)" (editEllipseClick)="buttonAction($event)" (bannerRefreshClick)="refreshGridBanner($event);" [parent_id]="parent_id+1" [resourceName]="_currentData.resouceDef.resource" [banner]="_currentData.bannerJson"></app-insurance-billing-form-grid> -->
          </div>
        </form>
      </div>
    }
    @if (_currentData.currentAction === 'IMAGE_VIEWER') {
      <div>
        <app-document-viewer [resourceName]="_currentData.resouceDef.resource"></app-document-viewer>
      </div>
    }
  </ng-template>
  <div dhs-modal></div>